/* __next_internal_client_entry_do_not_use__ PriceWithClientFormatMoney auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { formatMoney } from "@faire/web--source/common/money";
import omit from "lodash/omit";
import React from "react";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { Price } from "@faire/retailer/views/product/ProductDetails/Price/Price";
export var PriceWithClientFormatMoney = function(props) {
    var _props_min_option_wholesale_promo_price;
    var originalPrice = props.min_option_wholesale_price ? formatMoney({
        money: props.min_option_wholesale_price,
        omitCentsIfZero: true
    }) : "";
    var wholesalePrice = ((_props_min_option_wholesale_promo_price = props.min_option_wholesale_promo_price) === null || _props_min_option_wholesale_promo_price === void 0 ? void 0 : _props_min_option_wholesale_promo_price.discounted_item_price) ? formatMoney({
        money: props.min_option_wholesale_promo_price.discounted_item_price,
        omitCentsIfZero: true
    }) : originalPrice;
    var retailPrice = props.min_option_retail_price ? formatMoney({
        money: props.min_option_retail_price,
        omitCentsIfZero: true
    }) : "";
    var _useRetailerStore = useRetailerStore([
        "isUK"
    ]), isUKRetailer = _useRetailerStore.isUK;
    var clientPriceProps = _object_spread_props(_object_spread({}, omit(props, [
        "min_option_retail_price",
        "min_option_wholesale_promo_price",
        "min_option_retail_price"
    ])), {
        originalPrice: originalPrice,
        wholesalePrice: wholesalePrice,
        retailPrice: retailPrice,
        isUKRetailer: isUKRetailer
    });
    return /*#__PURE__*/ _jsx(Price, _object_spread({}, clientPriceProps));
};
